import Home from './components/Home.vue';
import About from './components/About.vue';
import Grants from './components/Grants.vue';
import Impact from './components/Impact.vue';
import Form from './components/Form.vue';
import error from './components/404.vue';

export const routes = [
    { path: '/', component: Home},
    { path: '/about', component: About },
    { path: '/contact', component: Form },
    { path: '/grants', component: Grants },
    { path: '/impact', component: Impact },
    { path: '*', component: error }
];